import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { key } from "@/env";
import socket from "@/socket";
import * as util from '@/util';
import { Notification } from "element-ui";

Vue.use(Vuex);


const state   = {
	app      : null,
	token    : null,
	userInfo : {},
	lang     : window.localStorage.getItem('BOLG-LANG') || 'zh',
	socket   : { status : false, host: '' },
	focusData: {},
    isChildIframe : false,
    wyy      : {
        cookie: '',
    },
    global: {
        setting: {
            show: {
                article: false,
            }
        }
    }
}

/* 修改数据的方法 (同步) */
const mutations = {
	/* 登录 */
	loginSuccess(state, user) {
        state.userInfo = user;
        window.localStorage.setItem(key.user, JSON.stringify(user));
    },
	/* 网易云登录 */
    wyyLoginSuccess(state, cookie) {
        state.wyy.cookie = cookie;
        window.localStorage.setItem(key.wyy_token, cookie);
    },
    setToken(state, token) {
		state.token    = token;
        axios.defaults.headers.Authorization = 'Bearer ' + token;
        window.localStorage.setItem(key.token, token);
        /* socket 初始化链接 */
        socket.init({
            callback: (status, host) => {
                state.socket.status = status;
                state.socket.host = host;
            }
        });
    },
	/* 修改语言配置 */
	changeSystemLang(state, data) {
		state.lang = data.lang;
	    window.localStorage.setItem('BOLG-LANG',data.lang);
	    window.location.reload();
	},
	/* 手动链接 websocket */
	initWebSocket(state, bus) {
		socket.init({
            callback: (status, host) => {
                state.socket.status = status;
                state.socket.host = host;
                Notification({
                title: status ? 'socket link success' : 'socket link error',
                type: status ? 'success' : 'error',
                position: 'bottom-right'
                });
		    }
        });
	},
	/* 关闭 websocket */
	closeWebSocket(state) {
		socket.close(() => {
			state.socket.status = false;
			Notification({
	          title: 'socket link has closed',
	          type: 'success',
	          position: 'bottom-right'
	        });
		});
	},
	/* 焦点数据 用来维护当前焦点数据 */
	setFocusData(state, data) {
		state.focusData = data;
	},
	/* 销毁焦点数据 */
	desroryFocusData(state) {
		state.focusData = {};
	},
}

/* 提交的操作 可包含任意异步操作 */
const actions = {
	
}


export default new Vuex.Store({
	state,
	mutations,
	actions
})



// WEBPACK FOOTER //
// ./src/vuex/index.js